<!-- eslint-disable vue/no-v-html -->
<template>
  <div ref="resultElement" class="result">
    <div v-show="error || isSuccess" class="error" :class="{ pos: error == null }">
      <span class="msg" v-html="message" />
      <a
        class="icon"
        @click="
          emit('update:error', null);
          emit('update:isSuccess', false);
        "
        >&#x274c;</a
      >
    </div>
  </div>
</template>

<!-- eslint-disable vue/no-v-html -->
<script setup>
import { computed, watch, ref } from "vue";

const emit = defineEmits(["update:error", "update:isSuccess"]);

const props = defineProps({
  error: [Error, String],
  isSuccess: Boolean,
  isNoScroll: Boolean,
});

const resultElement = ref(null);

const message = computed(() => {
  if (props.error != null) {
    var errMsg = "";
    if (props.error.response) {
      errMsg = props.error.response.data.toString();
    } else {
      errMsg = props.error.toString();
    }

    errMsg = errMsg.replace("Error: ", "");

    return errMsg;
  } else if (props.isSuccess === true) {
    return "Success!";
  }

  return "";
});

const scroll = () => {
  if (resultElement.value) {
    resultElement.value.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

watch(
  () => props.error,
  val => {
    if (val) {
      scroll();
    }
  }
);
watch(
  () => props.isSuccess,
  () => {
    if (!props.isNoScroll) {
      scroll();
    }
  }
);
</script>
